module.exports = __webpack_public_path__ + "static/media/vue-icon.19625dda.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/vue-icon.webp
// module id = 248
// module chunks = 1